import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { redirectReloadToHome } from './app/core/utils/refresh-navigation';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

redirectReloadToHome({
  baseUri: document.baseURI,
  history: window.history,
  location: window.location,
  performance: window.performance,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
